import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import TagManager from 'react-gtm-module';
import { LicenseInfo } from '@mui/x-license-pro';

import App from './App';
import config from './config';

import './index.css';

Amplify.configure(config);

const loading = document.querySelector('#placeholder');
if (loading) loading.remove();

if (config.googleTagManagerArgs) {
  TagManager.initialize(config.googleTagManagerArgs);
}

LicenseInfo.setLicenseKey(config.muiLicense);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

if ('serviceWorker' in navigator && document.location.protocol === 'https:') {
  const url = `${document.location.origin}/service-worker.js`;
  window.addEventListener('load', () => navigator.serviceWorker.register(url));
}
